import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { InventoryStockPage } from '@/features/inventory'

export const Route = createFileRoute('/_authenticated/inventory/stock')({
  component: () => (
    <RequirePermission permission='inventory_ledger.read'>
      <InventoryStockPage />
    </RequirePermission>
  ),
})
